import {
  ModalManager,
  useModal,
} from "@/react/components/Layout/ModalManagerProvider";
import { useCircleV4 } from "@/react/hooks/useCircleV4";

import type { FormRenderingContextValue } from "../contexts/FormRenderingContext";
import { FormRenderingProvider } from "../contexts/FormRenderingContext";
import { FormModalCompass } from "./FormModalCompass";
import { FormModalUIKit } from "./FormModalUIKit";

interface FormModalProps {
  formRenderingContextValue: FormRenderingContextValue;
}

const FormModal = ModalManager.create(
  ({ formRenderingContextValue }: FormModalProps) => {
    const modal = useModal();
    const { isCircleV4 } = useCircleV4();

    if (!modal.visible) return null;

    const onOpenChange = (open: boolean) => {
      if (open) return;
      void modal.hide();
    };

    const FormModalComponent = isCircleV4 ? FormModalCompass : FormModalUIKit;

    return (
      <FormRenderingProvider {...formRenderingContextValue}>
        <FormModalComponent open={modal.visible} onOpenChange={onOpenChange} />
      </FormRenderingProvider>
    );
  },
);

export const useFormModal = () => useModal(FormModal);
